
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 14,
  viewBox: "0 0 15 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.93 9.538a.437.437 0 0 1-.31-.747l6.837-6.837a.437.437 0 0 1 .619.619L3.239 9.41a.436.436 0 0 1-.31.128z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.253 12.689a.437.437 0 0 1-.428-.53l.676-3.15a.438.438 0 0 1 .856.183l-.676 3.151a.438.438 0 0 1-.428.346zm3.151-.677a.437.437 0 0 1-.31-.747l6.838-6.836a.438.438 0 0 1 .618.619l-6.836 6.836a.436.436 0 0 1-.31.128z",
  fill: "var(--theme-primary, #810ea9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.254 12.689a.438.438 0 0 1-.092-.866l3.15-.676a.438.438 0 0 1 .184.856l-3.15.676a.427.427 0 0 1-.092.01zm8.75-6.276a.436.436 0 0 1-.31-.128L8.22 3.81a.437.437 0 1 1 .619-.618l2.474 2.474a.437.437 0 0 1-.309.747zm1.236-1.237a.436.436 0 0 1-.309-.747 1.3 1.3 0 0 0 .378-.928 1.3 1.3 0 0 0-.378-.928 1.301 1.301 0 0 0-.928-.378 1.3 1.3 0 0 0-.928.378.437.437 0 1 1-.619-.619 2.17 2.17 0 0 1 1.547-.634 2.17 2.17 0 0 1 1.547.634c.409.409.634.958.634 1.547s-.225 1.138-.634 1.547a.435.435 0 0 1-.31.128z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"15\" height=\"14\" viewBox=\"0 0 15 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M2.93 9.538a.437.437 0 0 1-.31-.747l6.837-6.837a.437.437 0 0 1 .619.619L3.239 9.41a.436.436 0 0 1-.31.128z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path d=\"M2.253 12.689a.437.437 0 0 1-.428-.53l.676-3.15a.438.438 0 0 1 .856.183l-.676 3.151a.438.438 0 0 1-.428.346zM5.404 12.012a.437.437 0 0 1-.31-.747l6.838-6.836a.438.438 0 0 1 .618.619l-6.836 6.836a.436.436 0 0 1-.31.128z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path d=\"M2.254 12.689a.438.438 0 0 1-.092-.866l3.15-.676a.438.438 0 0 1 .184.856l-3.15.676a.427.427 0 0 1-.092.01zM11.004 6.413a.436.436 0 0 1-.31-.128L8.22 3.81a.437.437 0 1 1 .619-.618l2.474 2.474a.437.437 0 0 1-.309.747zM12.24 5.176a.436.436 0 0 1-.309-.747 1.3 1.3 0 0 0 .378-.928 1.3 1.3 0 0 0-.378-.928 1.301 1.301 0 0 0-.928-.378 1.3 1.3 0 0 0-.928.378.437.437 0 1 1-.619-.619 2.17 2.17 0 0 1 1.547-.634 2.17 2.17 0 0 1 1.547.634c.409.409.634.958.634 1.547s-.225 1.138-.634 1.547a.435.435 0 0 1-.31.128z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/pencil.34c740d375aff28012b86f7a47082cda.svg"),
        {
          React: SvgPencil,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      